// Default distances
let distanceFromRight = 32;
let distanceFromBottom = 16;

// Figure out the position of the podium button so we can place the jump-to-top button beside it
const getDistances = () => {
    const podiumFrame = document.querySelector<HTMLIFrameElement>('#podium-website-widget iframe');
    const podiumBody = podiumFrame?.contentDocument?.body;
    const podiumButton = podiumBody?.querySelector<HTMLButtonElement>('.ContactBubble > button');

    if (podiumFrame && podiumButton) {
        // Calculate the distance from the right edge of the screen to the left edge of the podium button
        const frameBounds = podiumFrame.getBoundingClientRect();
        const buttonBounds = podiumButton.getBoundingClientRect();

        const podiumBtnRightEdge = frameBounds.left + buttonBounds.right;
        const podiumBtnRightEdgeDistanceFromRight = window.innerWidth - podiumBtnRightEdge;

        distanceFromRight = podiumBtnRightEdgeDistanceFromRight; // add gap

        // Calculate the distance from the bottom of the screen to the bottom of the podium button
        const podiumBtnTopEdge = frameBounds.top + buttonBounds.top;
        const podiumBtnTopEdgeDistanceFromBottom = window.innerHeight - podiumBtnTopEdge;
        distanceFromBottom = podiumBtnTopEdgeDistanceFromBottom + 24; // add gap
    }

    document.body.style.setProperty('--smg-toast-right-pos', `${distanceFromRight}px`);
    document.body.style.setProperty('--smg-toast-bottom-pos', `${distanceFromBottom}px`);

    setTimeout(getDistances, 10);
};

getDistances();
